import { render, staticRenderFns } from "./BaseBasicPage.vue?vue&type=template&id=ea343604&"
import script from "./BaseBasicPage.vue?vue&type=script&lang=js&"
export * from "./BaseBasicPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports